var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import { traitClass } from "../Trait";
import { GeoJsonTraits } from "./GeoJsonTraits";
let CartoMapV3TableCatalogItemTraits = (_dec = traitClass({
  description: "Calls Carto V3 API to return GeoJSON. It supports the Query API and the Table API.\n\nTo use the Query API - see traits:\n- `cartoQuery`\n- `cartoGeoColumn`\n\nTo use the Table API - see traits:\n- `cartoTableName`\n- `cartoColumns`\n- `cartoGeoColumn`"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Access token",
  description: "The access token to pass to the Carto Maps API"
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Authorization token",
  description: "The authorization token to pass to the Carto Maps API"
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Base URL",
  description: 'Base URL for Carto API (eg "https://gcp-australia-southeast1.api.carto.com/")'
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Geo column name",
  description: "Column name of the geom at the table (used for Table and Query API)"
}), _dec6 = primitiveTrait({
  type: "string",
  name: "Carto SQL Query",
  description: "Carto SQL Query (used for Query API). If this is defined, then the Query API will be used instead of Table API."
}), _dec7 = primitiveTrait({
  type: "string",
  name: "Table name",
  description: 'Table fully qualified name - eg "carto-demo-data.demo_tables.airports". (used for Table API). Note if `cartoQuery` defined, then the Query API will be used instead of Table API.'
}), _dec8 = primitiveArrayTrait({
  type: "string",
  name: "Column",
  description: "Columns to retrieve from the layer, by default all are returned. (used for Table API)"
}), _dec(_class = (_class2 = class CartoMapV3TableCatalogItemTraits extends mixTraits(GeoJsonTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "accessToken", _descriptor, this);
    _initializerDefineProperty(this, "connectionName", _descriptor2, this);
    _initializerDefineProperty(this, "baseUrl", _descriptor3, this);
    _initializerDefineProperty(this, "cartoGeoColumn", _descriptor4, this);
    _initializerDefineProperty(this, "cartoQuery", _descriptor5, this);
    _initializerDefineProperty(this, "cartoTableName", _descriptor6, this);
    _initializerDefineProperty(this, "cartoColumns", _descriptor7, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "accessToken", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "connectionName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "carto_dw";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "baseUrl", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "https://gcp-australia-southeast1.api.carto.com/";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "cartoGeoColumn", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "geom";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "cartoQuery", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "cartoTableName", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "cartoColumns", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { CartoMapV3TableCatalogItemTraits as default };